import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { environment } from './../environments/environment';
import { Observable } from 'rxjs';
import { EncryptionService } from './Auth/encryption/encryption.service';
@Injectable({
  providedIn: 'root'
})
export class ServiceService {
  [x: string]: any;
  userListFilter = ''
  rftFilter: any
  rfrFilter: any
  constructor(private http: HttpClient, private encryptionService: EncryptionService) { }
/** Auth header for the manual fetch() calls (aiChat stream/extract) — HttpClient
   *  requests get this from LoginInterceptorInterceptor automatically; fetch()
   *  bypasses that interceptor entirely, so these two need it added by hand. */
  private authHeader(): { [k: string]: string } {
    const raw = localStorage.getItem('uidToken') || '';
    if (!raw) return {};
    try { return { Authorization: `Bearer ${this.encryptionService.decrypt(raw)}` }; }
    catch { return {}; }
  }

  //-----hold product name----------
  product_id = "";
  customer_id = "";
  department_id = "";
  employee_id = "";
  invoice_id = "";
  receipt_id = "";
  brand_id = "";
  user_id = "";
  KPI_id = "";
  Team_id = "";
  lead_id = "";
  order_id = "";
  advice_id = "";
  folder_id = "";
  production_id = "";
  admin_id: any

  /*-------test api new-----------------------*/
  // baseUrl="http://174.138.39.166:5000/";

  /*--------------old live api new----------------*/
  // baseUrl="http://159.223.188.108:5000/";

  /*--------------live api new----------------*/
  // baseUrl="http://3.1.26.23:5000/";

  /*--------------live api new----------------*/
  baseUrl = environment.baseUrl

  //==================start==============================================
  //----Ai for login----------

  // alert common function

  showToast(icon: SweetAlertIcon, title: string): void {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      }

    });
    Toast.fire({
      icon: icon,
      title: title
    });

  }

  Interviewdata = null
  createdTemplate: any
  // time parsing without local time

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'Invalid Date';
    // Extract date components using UTC methods
    const day = date.getUTCDate();
    const month = date.toLocaleString('default', { month: 'short', timeZone: 'UTC' });
    const year = date.getUTCFullYear();
    const weekday = date.toLocaleString('default', { weekday: 'long', timeZone: 'UTC' });

    // Extract time components using UTC methods
    let hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();

    // Determine AM/PM and adjust hours for 12-hour format
    const amPm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;  // Convert 0 to 12 for midnight

    // Format time as "hh:mm AM/PM"
    const formattedTime = `${this.padZero(hours)}:${this.padZero(minutes)} ${amPm}`;

    // Format as "dd MMM yyyy, EEEE hh:mm AM/PM"
    return `${this.padZero(day)} ${month} ${year}, ${formattedTime}`;

  }

  // Helper function to pad single-digit days with a leading zero
  private padZero(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }




  // minmumdate

  setMinDate(month: any): string {
    const date = new Date();
    date.setMonth(date.getMonth() + month);
    return date.toISOString().split('T')[0];
  }
  setMinDateday(day: any): string {
    const date = new Date();
    date.setDate(date.getDate() + day);

    // Return the ISO string formatted for datetime-local (YYYY-MM-DDTHH:MM)
    return date.toISOString().slice(0, 16);
  }


  Login(body: any) {

    return this.http.post<any>(this.baseUrl + "login", body);
  }
  //----Api for user logout----------
  Logout(body: any) {
    return this.http.post<any>(this.baseUrl + "userLogout", body);
  }

  updateLoginuser(body: any) {
    return this.http.put<any>(this.baseUrl + "updateLogin", body);
  }
  //----Api for data sunchronization----------
  DataSync() {

    return this.http.get<any>(this.baseUrl + "manualSyncdb");

  }
  ListStock(count: any) {
    return this.http.get<any>(this.baseUrl + "viewProductStock?offset=" + count + "&limit=20");
  }
  ListStockEach(Id: any) {
    return this.http.get<any>(this.baseUrl + "viewProductStock/" + Id);
  }
  //---Api for view brand by Id---------------
  ViewBrandById(Id: any) {
    return this.http.get<any>(this.baseUrl + "viewBrands" + Id);
  }
  //---Api for view KPI by Id---------------
  ViewKPIById(Id: any) {
    return this.http.get<any>(this.baseUrl + "viewKpi" + Id);
  }

  //---Api for view Team by Id---------------
  ViewTeamById(Id: any) {
    return this.http.get<any>(this.baseUrl + "viewSalespromoterKpi" + Id);
  }

  //------gunction for return base url------
  ReturnBase() {
    return this.baseUrl;
  }
  //---Api for view brand---------------
  ViewBrand() {
    return this.http.get<any>(this.baseUrl + "viewBrands");
  }
  //---Api for brand paging---------------
  ViewBrandPage(offset: any) {
    return this.http.get<any>(this.baseUrl + "viewBrands" + offset);
  }
  ViewDepartments() {
    return this.http.get<any>(this.baseUrl + "viewDepartments?limit=100");
  }
  //---Api for brand paging---------------
  ViewDepartmentsPage(offset: any) {
    return this.http.get<any>(this.baseUrl + "viewDepartments" + offset);
  }
  EditDepartment(body: any) {
    return this.http.put<any>(this.baseUrl + "updateDepartments", body);
  }

  //-----api for update warehouse---------
  updateWarehouses(body: any) {
    return this.http.put<any>(this.baseUrl + "updateWarehouses", body);
  }

  EditKPI(body: any) {
    return this.http.put<any>(this.baseUrl + "updateKpi", body);
  }
  EditSalesTeam(body: any) {
    return this.http.put<any>(this.baseUrl + "updateSalespromoterKpi", body);
  }
  //---Api for create lead------
  CreateLead(body: any) {
    return this.http.post<any>(this.baseUrl + "addContact", body);

  }
  //Api for Create saleorder------
  CreatesaleOrder(body: any) {
    return this.http.post<any>(this.baseUrl + "saleorder", body);
  }

  //Api for Create saleorder------
  CreateKPI(body: any) {
    return this.http.post<any>(this.baseUrl + "createKpi", body);
  }

  //Api for Create sales team------
  SalesTeam(body: any) {
    return this.http.post<any>(this.baseUrl + "createSalespromoterKpi", body);
  }
  //----Api for search customer------
  SearchCustomer(name: any) {
    return this.http.get<any>(this.baseUrl + "viewCustomers?customer_name=" + name);
  }

  customerDropdown() {
    return this.http.get<any>(this.baseUrl + "viewCustomers/customer_list/dropdown");
  }
  //----Api for QcPermittedDeviation view------
  QcPermittedDeviation() {
    return this.http.get<any>(this.baseUrl + "viewQcPermittedDeviation");
  }

  //----Api for search customer with admin id------
  NewSearchCustomer(name: any) {
    this.admin_id = localStorage.getItem('admin_id')
    return this.http.get<any>(this.baseUrl + "viewCustomers?employee_id=" + this.admin_id + "&customer_name=" + name);
  }

  //---Api for search Product------
  SearchProduct(name: any) {

    return this.http.get<any>(this.baseUrl + "viewProducts?product_name=" + name);

  }
  ProductDropdown() {
    return this.http.get<any>(this.baseUrl + "viewProducts/product_list/dropdown");
  }
  RawMaterialtDropdown() {
    return this.http.get<any>(this.baseUrl + "/viewCategories/list/dropdown");
  }
  SearchRawMaterialProduct(name: any) {
    return this.http.get<any>(this.baseUrl + "viewProducts/product_list/rawMaterials?product_name=" + name);
  }
  //---Api for create user---------
  userCreation(body: any) {
    return this.http.post<any>(this.baseUrl + "userCreation", body);

  }
  //------api for temp user creation -------///

  //---Api for create temporary user---------
createTemporaryUser(body: any) {
  return this.http.post<any>(this.baseUrl + "userCreation/createNewTemporaryEmployee", body);
}

//---Api for linking temporary employee to permanent employee---------
linkTemporaryEmployee(body: any) {
  return this.http.post<any>(this.baseUrl + "userCreation/linkTemporaryEmployee", body);
}
  //-----Api for search employee----
  SearchEmployee(name: any) {
    return this.http.get<any>(this.baseUrl + "viewEmployees?employee_name=" + name);
  }
  //---Api for list customer complaints
  CustomerComplaints() {

    return this.http.get<any>(this.baseUrl + "viewCustomers/customer_list/customer_complaints");
  }
  //---Api for customer details
  CutomerDetails(Id: any) {

    return this.http.get<any>(this.baseUrl + "viewCustomers" + Id);

  }
  //---Api for customer visit details-----
  CustomerVisitDetals(Id: any) {
    return this.http.get<any>(this.baseUrl + "viewVisit" + Id);

  }
  //-----Api for view visit-------
  ViewVisit(offset: any, body: any) {
    return this.http.post<any>(this.baseUrl + "viewVisit" + offset, body);
  }
  //----View visit without body------
  GetVisit(offset: any) {
    return this.http.get<any>(this.baseUrl + "viewVisit" + offset);
  }
  //----Api for view employee----
  ViewEmployee() {
    return this.http.get<any>(this.baseUrl + "viewEmployees");
  }

  ViewAllEmployee() {
    return this.http.get<any>(this.baseUrl + "viewEmployees/employee_list/employeeDropdown");
  }
  ViewAllEmployeefilter(filter: string) {
    return this.http.get<any>(this.baseUrl + "viewEmployees/employee_list/employeeDropdown" + filter);
  }
  ViewAllRmQcTechnicians() {
    return this.http.get<any>(this.baseUrl + "rm_qc_technicians/dropdown");
  }
  ViewAllRmQcTechniciansfilter(filter: string) {
    return this.http.get<any>(this.baseUrl + "rm_qc_technicians/dropdown" + filter);
  }
  ViewAllProcessQcTechnicians() {
    return this.http.get<any>(this.baseUrl + "process_qc_technicians/dropdown");
  }
  ViewAllProcessQcTechniciansfilter(filter: string) {
    return this.http.get<any>(this.baseUrl + "process_qc_technicians/dropdown" + filter);
  }

  ViewAllSalesPromoters(type: any) {
    return this.http.get<any>(this.baseUrl + "viewEmployees/employee_list/userTypeWise?user_type=" + type);
  }
  //----Api for view employee by id----
  ViewEmployeeById(Id: any) {
    return this.http.get<any>(this.baseUrl + "viewEmployees" + Id);
  }

  SearchEmployeeDate(Id: any, date: any) {
    return this.http.get<any>(this.baseUrl + "viewEmployees/" + Id + "?month_filter=" + date);
  }
  //---Api for view customer list---
  ViewCustomer(offset: any) {
    // return this.http.get<any>(this.baseUrl+"viewCustomers"+offset);
    this.admin_id = localStorage.getItem('admin_id')
    return this.http.get<any>(this.baseUrl + "viewCustomers/customer_list?employee_id=" + this.admin_id + '&' + offset);
  }

  //----Api for update brand----------
  UpdateBrand(body: any) {
    return this.http.put<any>(this.baseUrl + "updateBrands", body);
  }

  //----Api for updateAttendanceRequest----------
  updateAttendanceRequest(body: any) {
    return this.http.put<any>(this.baseUrl + "updateAttendanceRequest", body);
  }
  // multiple approval and reject 
  bulkUpdateAttendanceRequest(body: any) {
    return this.http.put<any>(this.baseUrl + "updateAttendanceRequest/multiple", body);
  }

  //----Api for createEmployeeAttendance (Web Punching)----------
  createEmployeeAttendance(body: any) {
    return this.http.post<any>(this.baseUrl + "createEmployeeAttendance", body);
  }

  //----Api for updateEmployeeAttendance (Web Punching)----------
  updateEmployeeAttendance(body: any) {
    return this.http.put<any>(this.baseUrl + "updateEmployeeAttendance", body);
  }
  // For BIOMETRIC Punching (NOT mobile)  
  updateFactoryPunchingAdjustment(body: any) {
    console.log("📡 Calling BIOMETRIC API: updateFactoryPunchingAdjustment");
    return this.http.put<any>(this.baseUrl + "updateFactoryPunchingAdjustment", body);
  }

  //-----Api for upload image-----
  UploadImage(body: any) {
body.append('employee_id', localStorage.getItem('admin_id'));
return this.http.post<any>(this.baseUrl + "updateBrands/brand_image", body);
}

  //---Api for get department--------
  ViewDepartment(Id: any) {
    return this.http.get<any>(this.baseUrl + "viewDepartments/department_dropdown" + Id);
  }

  //-----Api for update customer----
  UpdateCustomers(body: any) {
    return this.http.put<any>(this.baseUrl + "updateCustomers", body);

  }
  //----Api for update Employee----
  UpdateEmployee(body: any) {
    return this.http.put<any>(this.baseUrl + "updateEmployees", body);

  }
  //------view brand drop down----
  BrandDropdown() {

    return this.http.get<any>(this.baseUrl + "viewBrands/brand_dropdown");

  }
  //------view brand drop down----
  BrandDropdownById(Id: any) {

    return this.http.get<any>(this.baseUrl + "viewBrands/brand_dropdown" + Id);

  }
  //----Api for upload employee document-------
  UploadEmpDocument(body: any) {
  body.append('employee_id', localStorage.getItem('admin_id'));
  return this.http.post<any>(this.baseUrl + "updateEmployees/employee_document", body);
  }

  //---Api for view Contact-----
  ViewContact(Id: any) {
    return this.http.get<any>(this.baseUrl + "viewContact/" + Id);
  }
  //---Api for view Products
  ViewProducts(Id: any) {

    return this.http.get<any>(this.baseUrl + "viewProducts" + Id);

  }
  //----Api for update Products
  UpdateProduct(body: any) {

    return this.http.put<any>(this.baseUrl + "updateProducts", body);
  }
  //---Api fpr view paticular user privilege--
  UserPrivilege(Id: any) {
    return this.http.get<any>(this.baseUrl + "viewLogin/" + Id);
  }
  //---Api for view users details
  ViewUsers(count: any) {

    return this.http.get<any>(this.baseUrl + "viewLogin?offset=" + count + "&limit=20");
  }
  //--------for search user using  employee name----
  SearchUser(name: any, drop: any, count: any, isFactory?: boolean, isTemp: boolean = false) {
  const tempParam = isTemp ? '&is_temporary=true' : '';
  if (isFactory) {
    return this.http.get<any>(this.baseUrl + "viewLogin?employee_name=" + name + '&user_type=' + drop + '&offset=' + count + '&department_id=17897118-f762-11ea-90f2-00505697d21e' + tempParam);
  } else {
    return this.http.get<any>(this.baseUrl + "viewLogin?employee_name=" + name + '&user_type=' + drop + '&offset=' + count + tempParam);
  }
}
  //---Api for view department working days list
  ViewKPI(count: any) {

    return this.http.get<any>(this.baseUrl + "viewKpi?offset=" + count + "&limit=20");
  }

  //---Api for view warehouse list
  viewWarehouses(count: any) {

    return this.http.get<any>(this.baseUrl + "viewWarehouses?offset=" + count + "&limit=20");
  }
  //---Api for view sales team
  //---Api for view sales team
  ViewSalesTeam(count: any, monthFilter: string = '') {
    let url = this.baseUrl + "viewSalespromoterKpi?offset=" + count + "&limit=20";

    // Add month filter if provided
    if (monthFilter) {
      url += "&month_filter=" + monthFilter + "-01"; // Convert YYYY-MM to YYYY-MM-DD format
    }

    return this.http.get<any>(url);
  }
  //------Api for delete users----
  DeleteUser(Id: any) {
    return this.http.delete<any>(this.baseUrl + "viewLogin/" + Id);
  }

  //-------api for delete rfr-----
  DeleteRfr(Id: any) {

    return this.http.delete<any>(this.baseUrl + "viewRequestForResolution/" + Id);
  }

  //------Api for delete kyc----
  DeleteKyc(Id: any) {
    return this.http.delete<any>(this.baseUrl + "viewKyc/" + Id);
  }

  //------Api for delete kpi----
  DeleteKPI(Id: any) {

    return this.http.delete<any>(this.baseUrl + "viewKpi/" + Id);

  }
  //--------kpi monthly report apis-----------//

  kpiAssignTarget(body: any) {
    return this.http.put<any>(this.baseUrl + 'kpiReport/assignTarget', body);
  }

  getKpiReport(employeeId: string, month: string) {
    return this.http.get<any>(
      this.baseUrl + 'kpiReport/report/' + employeeId + '?month=' + month
    );
  }

  downloadKpiExcel(employeeIds: string[], month: string) {
    return this.http.post(
      `${this.baseUrl}kpiReport/excelReport/download`,
      { month: month, employeeIds: employeeIds },
      { responseType: 'blob', observe: 'response' }
    );
  }

  //-------batch posting apis------//
  // Batch Posting Cycle Time Matrix APIs
  batchPostingCycleTimeListing(search: string) {
    return this.http.get<any>(this.baseUrl + "batchPostingCycleTimeMatrix" + search);
  }
  batchPostingCycleTimeCreate(body: any) {
    return this.http.post<any>(this.baseUrl + "batchPostingCycleTimeMatrix", body);
  }
  batchPostingCycleTimeDetails(id: string) {
    return this.http.get<any>(this.baseUrl + "batchPostingCycleTimeMatrix/" + id);
  }
  batchPostingCycleTimeUpdate(id: string, body: any) {
    return this.http.put<any>(this.baseUrl + "batchPostingCycleTimeMatrix", body);
  }
  batchPostingCycleTimeDelete(body: any) {
    return this.http.delete<any>(this.baseUrl + "batchPostingCycleTimeMatrix", { body: body });
  }
  batchPostingSummaryReport(startDate: string, endDate: string, processCategory: string = '', productionType: string = '', offset: number = 0, limit: number = 10, departmentId: string = '', deviationStatus: string = '') {
    let params = `?startDate=${startDate}&endDate=${endDate}&offset=${offset}&limit=${limit}&is_factory=true`;
    if (processCategory) params += `&processCategory=${processCategory}`;
    if (productionType) params += `&productionType=${encodeURIComponent(productionType.trim())}`;
    if (departmentId) params += `&department_id=${departmentId}`;
    if (deviationStatus) params += `&status=${deviationStatus}`;
    return this.http.get<any>(this.baseUrl + 'batchPostingSummaryReport' + params);
  }
  batchPostingSummaryReportDetail(id: string) {
    return this.http.get<any>(this.baseUrl + 'batchPostingSummaryReport/' + id);
  }

  getManualEntryList(startDate: string, endDate: string, departmentId: string, processCategory: string = '', productionType: string = '', offset: number = 0, limit: number = 20) {
    let params = `?start_date=${startDate}&end_date=${endDate}&offset=${offset}&limit=${limit}`;
    if (departmentId) params += `&department_id=${departmentId}`;
    if (processCategory) params += `&processCategory=${processCategory}`;
    if (productionType) params += `&productionType=${encodeURIComponent(productionType.trim())}`;
    return this.http.get<any>(this.baseUrl + 'viewErpProductionList' + params);
  }
  factoryDepartmentDropdown() {
    return this.http.get<any>(this.baseUrl + "viewDepartments/department_dropdown?is_factory=true");
  }

  //------api for the vacation monitoring----------

  getLeaveDashboard(yearMonth?: string) {
    let url = this.baseUrl + 'leaveRequestDashboard';
    if (yearMonth) {
      url += '?year_month=' + yearMonth;
    }
    return this.http.get<any>(url);
  }

  //-----api for the customer classification monthly report

  downloadCustomerClassificationExcel(body: any) {
    return this.http.post(
      this.baseUrl + 'customerClassification/report/download',
      body,
      { responseType: 'blob', observe: 'response' }
    );
  }

  getEmployeesByMultipleUserTypes(body: any) {
    return this.http.post<any>(this.baseUrl + "viewEmployees/employee/multipleUserType", body);
  }

  //-----Apis for the messaging broadcast(whatsapp message broadcasting)------//
  getBroadcastMobileDropdown() {
    return this.http.get<any>(this.baseUrl + "createWhatsappBroadcast/broadcastSender/dropdown");
  }

  getBroadcastTemplateDropdown(accountId: string = '') {
    let url = this.baseUrl + "createWhatsappBroadcast/broadcastTemplate/dropdown";
    if (accountId) url += `?whatsapp_business_account_id=${accountId}`;
    return this.http.get<any>(url);
  }

  //------Api for delete sales team----
  DeleteSalesTeam(Id: any) {
    return this.http.delete<any>(this.baseUrl + "viewSalespromoterKpi/" + Id);
  }
  //----Api for password reset----
  PasswordReset(body: any) {
    return this.http.post<any>(this.baseUrl + "updateLogin/passwordreset", body);
  }

  //----Api for createUserWorkingDays----
  createUserWorkingDays(body: any) {
    return this.http.post<any>(this.baseUrl + "createUserWorkingDays", body);
  }

  //----Api for updateEmployeeKpi----
  updateEmployeeKpi(body: any) {
    return this.http.put<any>(this.baseUrl + "updateEmployeeKpi", body);
  }

  //----Api for updateKpiSalespromoter----
  updateKpiSalespromoter(body: any) {
    return this.http.put<any>(this.baseUrl + "updateKpiSalespromoter", body);
  }


  deleteUserWorkingDays(Id: any) {
    return this.http.delete<any>(this.baseUrl + "deleteUserWorkingDays/" + Id);
  }
  viewUserWorkingDays(Id: any) {

    return this.http.get<any>(this.baseUrl + "viewUserWorkingDays?user_id=" + Id);
  }
  viewUserWorkingDaysEach(Id: any) {

    return this.http.get<any>(this.baseUrl + "viewUserWorkingDays/" + Id);
  }

  updateUserWorkingDays(body: any) {
    return this.http.put<any>(this.baseUrl + "updateUserWorkingDays", body);
  }

  //--------api for post privileges-------//
  postPrivileges(data: any, options: any) {
    console.log("call postprivilege")
    return this.http.post(this.baseUrl + "UpdateLogin/update_privilege", data, options);

  }
  //---Api for view privileges------
  ViewPrivileges() {
    return this.http.get<any>(this.baseUrl + "viewPrivilege");
  }
  //----
  SearchEmpDepartment(Id: any) {
    return this.http.get<any>(this.baseUrl + "viewEmployees/employee_list/department?department=" + Id);
  }
  getEmployeesDropdown(Id: any) {
    return this.http.get<any>(this.baseUrl + "viewEmployees/employee_list/department/dropdown?department=" + Id);
  }
  //-----Api for inviice details----
  InvoiceDetails(Id: any) {

    return this.http.get<any>(this.baseUrl + "viewInvoices" + Id);

  }
  //---Api for view leads--
  ViewLeades(Id: any) {
    return this.http.get<any>(this.baseUrl + "viewContact" + Id);
  }
  //----Api for delete leads----
  DeleteLeads(Id: any) {
    return this.http.delete<any>(this.baseUrl + "viewContact" + Id);
  }
  //------Api for get product complaint list---
  GetProductComplaintList(Id: any) {
    return this.http.get<any>(this.baseUrl + "viewProducts//product_list/product_complaints" + Id);
  }
  //----Api for view receipt by Id
  ReceiptById(Id: any) {

    return this.http.get<any>(this.baseUrl + "viewReceipts" + Id);
  }
  //---Api for view order by Id
  OrderById(Id: any) {

    return this.http.get<any>(this.baseUrl + "viewSaleorder/" + Id);
  }
  //---Api for cancel order by Id
  CancelOrder(Id: any) {

    return this.http.get<any>(this.baseUrl + "viewSaleorder/update/" + Id);
  }
  //---Api for add privilege------
  AddPrivilege(body: any) {
    return this.http.post<any>(this.baseUrl + "addPrivilege", body);
  }
  //------Api for delete privilege-----
  DeletePrivilege(Id: any) {

    return this.http.delete<any>(this.baseUrl + "viewPrivilege/" + Id);

  }
  //---function for file upload-------
  FileUopload(data: any) {
  const employeeId = localStorage.getItem('admin_id') || '';
  return this.http.post<any>(this.baseUrl + "fileUpload?employee_id=" + employeeId, data);
}
  removeFile(fileId: string) {
    return this.http.delete<any>(this.baseUrl + "remove-file", { body: { fileId } });
  }
  //----function for get product advice list------
  GetAdviceList(count: any) {
    return this.http.get<any>(this.baseUrl + "viewProductionadvice?offset=" + count + "&limit=20");
  }

  //----function for get AttendanceRequest------
  viewAttendanceRequest(count: any, status?: string) {
    let url = this.baseUrl + "viewAttendanceRequest?offset=" + count + "&limit=20";

    // Add status parameter if provided
    if (status) {
      url += "&status=" + status;
    }

    return this.http.get<any>(url);
  }
  viewAttendanceRequestDetails(id: any) {
    return this.http.get<any>(this.baseUrl + "viewAttendanceRequest/" + id);
  }
  //-------function for get advice details----------
  GetAdviceDetails(Id: any) {
    return this.http.get<any>(this.baseUrl + "viewProductionadvice/" + Id);
  }
  //-----function for set advice id-------------
  SetAdviceId(Id: any) {
    this.advice_id = Id;
  }
  //-----function for get advice id-------------
  GetAdviceId() {
    return this.advice_id;
  }
  //----function for set admin id--------
  SetAdminId(Id: any) {
    this.admin_id = Id;
  }
  //----function for get admin id--------
  GetAdminId() {
    return this.admin_id;
  }
  //----function for listing shans app folder-------
  GetFolder(count: any) {
    return this.http.get<any>(this.baseUrl + "viewShansappFolder?offset=" + count + "&limit=20");
  }
  //--------gunction for get each folder details-------
  GetFolderEach(Id: any) {
    return this.http.get<any>(this.baseUrl + "viewShansappFolder/" + Id);
  }
  //----function for listing shans app folder-------
  GetFolderDropdown() {
    return this.http.get<any>(this.baseUrl + "viewShansappFolder/product_list/folder_dropdown");
  }
  //----function for create sub folder---------
  CreateSubFolder(data: any) {
    return this.http.post<any>(this.baseUrl + "shansappSubFolder_creation", data);
  }
  //--------function for create shan's app folders----
  CreateFolder(data: any) {
    return this.http.post<any>(this.baseUrl + "shansappFolder_creation", data);
  }
  //----function for update gunction name-------------
  UpdateFolder(data: any) {
    return this.http.put<any>(this.baseUrl + "updateShansappFolder", data);
  }
  //-------function for delete folder-----------
  DeleteFolder(Id: any) {
    return this.http.delete<any>(this.baseUrl + "viewShansappFolder/" + Id);
  }
  //----function for folder drop down-------------------
  FolderDropdown() {
    return this.http.get<any>(this.baseUrl + "viewShansappFolder/product_list/folder_dropdown");
  }
  //----function for delete sub folder---------
  DeleteSubFolder(Id: any) {
    return this.http.delete<any>(this.baseUrl + "viewShansappSubFolder/" + Id);
  }
  //------function for edit sub folder---------
  EditSubFolder(data: any) {
    return this.http.put<any>(this.baseUrl + "updateShansappSubFolder", data);
  }

  //----function for listing machine-------
  GetMachine(count: any) {
    return this.http.get<any>(this.baseUrl + "viewMachineList/machine_list/machine_dropdown?offset=" + count + "&limit=20");
  }
  //--------function for create machine----
  AddMachine(data: any) {
    return this.http.post<any>(this.baseUrl + "machineListCreation", data);
  }
  //-------function for delete machine-----------
  DeleteMachine(Id: any) {
    return this.http.delete<any>(this.baseUrl + "viewMachineList/" + Id);
  }
  //------function for get product folder---------
  GetProductFolder() {
    return this.http.get<any>(this.baseUrl + "viewProductFolders/folder_list/shansapp_folder_dropdown");
  }
  //----function for get each product folder detail
  GetProductFolderEach(Id: any) {
    return this.http.get<any>(this.baseUrl + "viewProductFolders/" + Id);
  }
  //----function for get customer approval list----
  GetCustomerApp(count: any) {
    return this.http.get<any>(this.baseUrl + "viewCustomerLocationApprovalList?offset=" + count + "&limit=20");
  }
  //----function for get KYc list----
  listkyc() {
    return this.http.get<any>(this.baseUrl + "viewKyc");
  }

  //----function for get qatar market study list----
  viewQatarMarketStudy() {
    return this.http.get<any>(this.baseUrl + "viewQatarMarketStudy/qatarMarketStudyList/qatar_market_study_dropdown");
  }
  viewMarketStudy(search?: string) {
    if (search == undefined) {
      search = ''
    }
    return this.http.get<any>(this.baseUrl + "viewMarketStudy/list/all" + search);
  }

  viewMarketingCampaign(search?: string) {
    if (search == undefined) {
      search = ''
    }
    return this.http.get<any>(this.baseUrl + "viewMarketCampaign" + search);
  }
  viewMarketingCampaignAll(search?: string) {
    if (search == undefined) {
      search = ''
    }
    return this.http.get<any>(this.baseUrl + "viewMarketCampaign/list/all" + search);
  }

  viewMarketingTeamDropdown() {
    return this.http.get<any>(this.baseUrl + "viewMarketingTeam/dropdown");
  }

  viewMarketCountry() {
    return this.http.get<any>(this.baseUrl + "viewMarketingCountry");
  }
  viewMarketState(id: any) {
    return this.http.get<any>(this.baseUrl + "viewMarketingState?marketing_country_id=" + id);
  }
  viewMarketArea(id: any) {
    return this.http.get<any>(this.baseUrl + "viewMarketingArea?marketing_state_id=" + id);
  }

  // Customer Survey APIs

  viewSurveyTemplates(params: any) {
    return this.http.get<any>(
      this.baseUrl + "factoryCustomerSurveyAdmin/viewTemplates",
      { params }
    );
  }

  viewSurveyTemplateById(templateId: string) {
    return this.http.get<any>(
      this.baseUrl + `factoryCustomerSurveyAdmin/viewTemplates/${templateId}`
    );
  }

  // Create new survey template
  createSurveyTemplate(data: any) {
    return this.http.post<any>(
      this.baseUrl + "factoryCustomerSurveyAdmin/createTemplate",
      data
    );
  }

  // Get survey template by ID (for edit mode)
  getSurveyTemplateById(templateId: string) {
    return this.http.get<any>(
      this.baseUrl + `factoryCustomerSurveyAdmin/viewTemplates/${templateId}`  // Changed from viewTemplate to viewTemplates
    );
  }

  getSurveyInstanceById(surveyId: string) {
    return this.http.get<any>(
      this.baseUrl + `factoryCustomerSurveyAdmin/viewSurveyInstances/${surveyId}`
    );
  }

  // Update survey template
  updateSurveyTemplate(templateId: string, data: any) {
    return this.http.put<any>(
      this.baseUrl + `factoryCustomerSurveyAdmin/updateTemplate`,  // Changed - backend expects template_id in body, not URL
      { template_id: templateId, ...data }
    );
  }

  // Delete survey templates
  deleteSurveyTemplates(templateIds: string[]) {
    return this.http.delete<any>(  // Changed from POST to DELETE
      this.baseUrl + "factoryCustomerSurveyAdmin/deleteTemplates",
      { body: { template_ids: templateIds } }
    );
  }

  createSurveyInstance(data: any) {
    return this.http.post<any>(
      this.baseUrl + "factoryCustomerSurveyAdmin/createSurveyInstance",
      data
    );
  }
  viewSurveyInstances(params: any) {
    return this.http.get<any>(
      this.baseUrl + "factoryCustomerSurveyAdmin/viewSurveyInstances",
      { params }
    );
  }

  deleteSurveyInstances(surveyIds: string[]) {
    return this.http.delete<any>(
      this.baseUrl + "factoryCustomerSurveyAdmin/deleteSurveyInstances",
      { body: { survey_ids: surveyIds } }
    );
  }

  assignEmployeesCustomers(data: any) {
    return this.http.post<any>(
      this.baseUrl + "factoryCustomerSurveyAdmin/assignEmployeesCustomers",
      data
    );
  }

  getMyAssignments(employeeId?: string) {
    const params: any = {};
    if (employeeId) {
      params.employee_id = employeeId;
    }
    return this.http.get<any>(
      this.baseUrl + "factoryCustomerSurveyEmployee/myAssignments",
      { params }
    );
  }

  viewAllResponses(params: any) {
    return this.http.get<any>(
      this.baseUrl + "factoryCustomerSurveyAdmin/viewAllResponses",
      { params }
    );
  }

  deleteSurveyResponses(response_ids: string[]) {
    return this.http.request('DELETE', `${this.baseUrl}factoryCustomerSurveyAdmin/deleteSurveyResponses`, {
      body: { response_ids },
      headers: { 'Content-Type': 'application/json' }
    });
  }

  // Get survey with questions
  getSurveyDetail(surveyId: string, params: any = {}) {
    return this.http.get<any>(
      this.baseUrl + `factoryCustomerSurveyEmployee/surveyDetail/${surveyId}`,
      { params }
    );
  }

  // Submit feedback
  submitFeedback(data: any) {
    return this.http.post<any>(
      this.baseUrl + "factoryCustomerSurveyEmployee/submitFeedback",
      data
    );
  }

  createCustomerSurvey(body: any) {
    return this.http.post<any>(this.baseUrl + "FactoryCustomerSurvey/createQuestionnaires", body);
  }

  viewCustomerSurveys(params: string) {
    return this.http.get<any>(this.baseUrl + "FactoryCustomerSurvey/viewCreatedQuestionnaires" + params);
  }

  getCustomerSurveyDetail(id: string) {
    return this.http.get<any>(this.baseUrl + "FactoryCustomerSurvey/viewCreatedQuestionnaires/" + id, {
      headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache' }
    });
  }

  updateCustomerSurvey(updateData: any) {
    return this.http.put<any>(`${this.baseUrl}FactoryCustomerSurvey/updateCreatedQuestionnaires`, updateData);
  }

  submitSurveyResponse(id: string, body: any) {
    return this.http.post<any>(this.baseUrl + "FactoryCustomerSurvey/submit/" + id, body);
  }

  createCustomerSurveyQuestionnaire(data: any) {
    return this.http.post<any>(this.baseUrl + "FactoryCustomerSurvey/createQuestionnaires", data);
  }
  updateCustomerSurveyQuestionnaire(data: any) {
    return this.http.put<any>(`${this.baseUrl}FactoryCustomerSurvey/updateupdateCreatedQuestionnaires`, data);
  }

  viewCustomerSurveyFeedback(employeeId: string, status?: string) {
    let params: any = { employee_id: employeeId };
    if (status) {
      params.status = status;
    }
    return this.http.get<any>(`${this.baseUrl}FactoryCustomerSurvey/view-feedback`, { params });
  }

  // POST - Add feedback
  addCustomerSurveyFeedback(surveyId: string, data: any) {
    return this.http.post<any>(`${this.baseUrl}FactoryCustomerSurvey/add-feedback`, data);
  }

  getCustomerFeedback(surveyId: string, customerId: string) {
    return this.http.get<any>(`${this.baseUrl}FactoryCustomerSurvey/get-feedback/${surveyId}/${customerId}`);
  }

  deleteCustomerSurvey(surveyIds: string[]) {
    return this.http.delete<any>(`${this.baseUrl}FactoryCustomerSurvey/delete`, {
      body: { survey_ids: surveyIds }
    });
  }


  // addCustomerSurveyFeedback(surveyId: string, data: any) {
  //   return this.http.post<any>(`${this.baseUrl}FactoryCustomerSurvey/add-feedback`, data);
  // }

  // addCustomerSurveyFeedback(surveyId: string, data: any) {
  //   return this.http.put<any>(`${this.baseUrl}FactoryCustomerSurvey/update/${surveyId}`, data);
  // }

  /**
   * Export survey to Excel
   * GET /customer-survey/export/{id}
   */
  exportSurveyToExcel(id: string) {
    return this.http.get(this.baseUrl + "FactoryCustomerSurvey/export/" + id, { responseType: 'blob' });
  }

  /**
   * Get survey summary
   * GET /customer-survey/summary
   */
  getSurveySummary(params?: string) {
    const url = params ?
      this.baseUrl + "FactoryCustomerSurvey/summary" + params :
      this.baseUrl + "FactoryCustomerSurvey/summary";
    return this.http.get<any>(url);
  }

  //----function for get qatar market study list----
  viewJabelaliMarketStudy() {
    return this.http.get<any>(this.baseUrl + "viewJabelaliMarketStudy");
  }
  //-------function for get Aqouz bm maret study list------
  viewAqouzbmmarketstudy() {
    return this.http.get<any>(this.baseUrl + "viewAlquozBmMarketStudy")
  }
  //-------function for get nepal wood market study------
  viewnepalwoodmarketstudy() {
    return this.http.get<any>(this.baseUrl + "viewNepalWoodMarketStudy")
  }
  //-------function for get nepal automotive market study-------
  viewnepalautomotivemarketstudy() {
    return this.http.get<any>(this.baseUrl + "viewNepalAutomotiveMarketStudy")
  }

  //----function for get KYc list----
  listMarketingVisit() {
    return this.http.get<any>(this.baseUrl + "viewMarketingVisit");
  }
  //----function for get KYc list----
  listMarketingVisitSearch(name: any) {
    return this.http.get<any>(this.baseUrl + "viewMarketingVisit?created_by_name=" + name);
  }

  //------function for update customer approval status----
  UpdateCustStatus(data: any) {
    return this.http.put<any>(this.baseUrl + "updateCustomerLocationApprovalList", data);
  }
  //-------function for customer approvals search-------
  CustomerAppSearch(count: any, name: any) {
    return this.http.get<any>(this.baseUrl + "viewCustomerLocationApprovalList?offset=" + count + "&limit=20&customer_name=" + name);
  }

  //-------function for customer approvals search-------
  EmployeeAppSearch(count: any, name: any) {
    return this.http.get<any>(this.baseUrl + "viewCustomerLocationApprovalList?offset=" + count + "&limit=20&employee_name=" + name);
  }
  //----function for list production----------
  GetProduction(count: any) {
    return this.http.get<any>(this.baseUrl + "viewProduction?offset=" + count + "&limit=20");
  }
  GetProductionfilter(count: any, filter: string) {
    return this.http.get<any>(this.baseUrl + "viewProduction?offset=" + count + "&limit=20" + filter);
  }
  //----function for production details each------
  GetProductionEach(Id: any) {
    return this.http.get<any>(this.baseUrl + "viewProduction/" + Id);
  }
  //---functuion for list sales projection--------
  GetSaleProjection(count: any, Id: any) {
    return this.http.get<any>(this.baseUrl + "viewProjection?offset=" + count + "&limit=20&employee_id=" + Id);
  }

  //---functuion for list employee kpi--------
  EmployeeKpi(data: any) {
    return this.http.get<any>(this.baseUrl + "viewEmployees/employee_list/kpi_excelSheet?" + data);
  }

  //---functuion for list Salespromoter kpi--------
  viewKpiSalespromoter(data: any) {
    return this.http.get<any>(this.baseUrl + "viewKpiSalespromoter?" + data);
  }

  //---functuion for list employee kpi--------
  viewEmployeeKpi(data: any) {
    return this.http.get<any>(this.baseUrl + "viewEmployeeKpi?" + data);
  }

  //---functuion for get sales promoter report--------
  viewSalesPromoterReport(month: any, data: any) {
    return this.http.post<any>(this.baseUrl + "viewSalesPromoterReport?" + month, data);
  }


  ViewSalesProjection(Id: any) {
    return this.http.get<any>(this.baseUrl + "viewProjection/" + Id);
  }
  //----function for search sale projection------
  GetSaleProjectionSearch(count: any, name: any, Id: any) {
    return this.http.get<any>(this.baseUrl + "viewProjection?offset=" + count + "&limit=20&customer_name=" + name + "&employee_id=" + Id);
  }
  GetSaleProjectionbrandwise(count: any, name: any, Id: any, body: any) {
    // debugger
    return this.http.post<any>(this.baseUrl + "viewProjectionBrandwise?offset=" + count + "&limit=20&customer_name=" + name + "&employee_id=" + Id, body);
  }
  GetSaleProjectionbrandwiseINV(id: any) {
    // debugger
    return this.http.get<any>(this.baseUrl + "viewProjectionBrandwise/" + id);
  }

  downloadSalesProjectionExcel(month_filter: string, user_type: string, department_id: string) {
    const body: any = { month_filter: month_filter };
    if (department_id) body.department_id = department_id;
    if (user_type) body.user_type = user_type;
    return this.http.post(
      this.baseUrl + "viewProjectionBrandwise/sales-projection-excel",
      body,
      { responseType: 'blob', observe: 'response' }
    );
  }
  // function For view department
  ViewDepartmentID(Id: any) {
    return this.http.get<any>(this.baseUrl + "viewDepartments/" + Id);
  }
  //---Api for get department--------
  departmentDropdown() {
    return this.http.get<any>(this.baseUrl + "viewDepartments/department_dropdown");
  }

  viewEmployeeAttendance() {
    return this.http.get<any>(this.baseUrl + "viewEmployeeAttendance/employee_list/admin");
  }

  viewEmployeeAttendanceFilter(string: any) {
    return this.http.get<any>(this.baseUrl + "viewEmployeeAttendance/employee_list/admin" + string);
  }
  viewRequestForResolution(value: any, count: any) {
    this.admin_id = localStorage.getItem('admin_id')
    return this.http.get<any>(this.baseUrl + "viewRequestForResolution?user_id=" + this.admin_id + value + "&offset=" + count + "&limit=20");
  }
  updateRequestForResolution(body: any) {
    return this.http.put<any>(this.baseUrl + "updateRequestForResolution", body);
  }

  // Department edits
  Warehouse_Dropdown() {
    return this.http.get<any>(this.baseUrl + "viewWarehouses/warehouse_list/warehouse_dropdown");
  }





  //===============================end==============================
  //---function for set projection id
  SetProductionId(Id: any) {
    this.production_id = Id
  }
  //---function for get projection id
  GetProductionId() {
    return this.production_id;
  }
  //-------Api post-----------//
  postData(postUrl: any, data: any) {
    console.log("call post")
    return this.http.post<any>(postUrl, data);

  }
  //---set folder id--------
  SetFolderId(Id: any) {
    this.folder_id = Id;
  }
  //----get folder id-----
  GetFolderId() {
    return this.folder_id;
  }
  //--------Api get--------------//
  getData(getUrl: any) {

    return this.http.get<any>(getUrl);

  }

  //----------Api put-------------//
  putData(putUrl: any, data: any) {

    return this.http.put<any>(putUrl, data);

  }

  //----------Api delete-------------//
  deleteData(deleteUrl: any) {

    return this.http.delete<any>(deleteUrl);

  }
  //----function for set lead id-----
  setLeadId(value: any) {

    this.lead_id = value;
    console.log("value=", value)

  }
  //-----function for get lead id----
  getLeadId() {

    return this.lead_id;
  }

  //----function for set product id-----
  setProductId(value: any) {

    this.product_id = value;
    console.log("value=", value)

  }
  //-----function for get product id----
  getProductId() {

    return this.product_id;
  }

  //----function for set employee id--------
  setEmployeeId(value: any) {

    this.employee_id = value
    console.log("value=", value)

  }
  //-----function for get employee id----
  getEmployeeId() {

    return this.employee_id
  }
  //----function for set customer id-------
  setCustomerId(value: any) {

    this.customer_id = value
    //console.log("value=",value)

  }

  //----function for set department id-------
  setDepartmentId(value: any) {

    this.department_id = value
    //console.log("value=",value)

  }

  //----function for set brand id--------
  setBrandId(value: any) {
    this.brand_id = value
    console.log("value=", value)

  }
  //----function for set user id--------
  setUserId(value: any) {

    this.user_id = value
    console.log("value=", value)

  }
  //-----function for get KPI id----
  getKPIId() {

    return this.KPI_id
  }

  //-----function for get employee id----
  getSalesTeamId() {

    return this.Team_id
  }

  //----function for set KPI id--------
  setKPIId(value: any) {
    this.KPI_id = value
    console.log("value=", value)
  }

  //----function for set KPI id--------
  setSalesTeamId(value: any) {
    this.Team_id = value
    console.log("value=", value)
  }

  //-----function for get employee id----
  getUserId() {

    return this.user_id
  }
  //----function for get brand id--------
  getBrandId() {

    return this.brand_id

  }
  //-----function for get customer id----
  getCustomerId() {

    return this.customer_id
  }

  //-----function for get customer id----
  getDepartmentId() {

    return this.department_id
  }
  //----function for set invoice id-------
  setInvoiceId(value: any) {

    this.invoice_id = value
    //console.log("value=",value)

  }
  //-----function for get invoice id----
  getInvoiceId() {

    return this.invoice_id
  }
  //----function for set receipt id-------
  setReceiptId(value: any) {

    this.receipt_id = value
    //console.log("value=",value)

  }
  //-----function for get receipt id----
  getReceiptId() {

    return this.receipt_id
  }
  //---function for load image
  loginImg(url: any) {
    return this.http.get(url, { responseType: 'blob' });
  }

  //-----function for set order id
  setOrderId(value: any) {
    this.order_id = value
  }
  //------function for get order Id
  getOrderId() {
    return this.order_id;
  }

  // new salesman reports
  viewAllSalesman(params: any) {
    return this.http.get<any>(this.baseUrl + `viewEmployees/employee_list/userTypeWise?user_type=${params}`);
  }
  viewSalesmanReport(parms: any, data: any) {
    return this.http.post<any>(this.baseUrl + "viewSalesmanReport?" + parms, data);
  }
  // kpirevert
  viewKpiRevertRequest(count: any) {
    return this.http.get<any>(this.baseUrl + "viewKpiRevertRequest?" + count);
  }
  updateKpiRevertRequest(body: any) {
    return this.http.put<any>(this.baseUrl + "updateKpiRevertRequest", body);
  }

  productMatch(body: any) {
    return this.http.post<any>(this.baseUrl + "viewProducts/excelUpload/productMatch", body)
  }

  interProductMatch(search: string) {
    return this.http.get<any>(`${this.baseUrl}viewProducts/product_list/intermediate_goods?product_name=${search}`)
  }

  productCategoryDropDown() {
    return this.http.get<any>(this.baseUrl + "viewCategories/list/dropdown")
  }
  processCategoryDropDown() {
    return this.http.get<any>(this.baseUrl + "processCategory/view/list/dropdown")
  }
  
  matrixHistoryKeeping(matrix_type: string, offset: number = 0, limit: number = 20) {
    const search = `?matrix_type=${matrix_type}&offset=${offset}&limit=${limit}&sort_order=desc`;
    return this.http.get<any>(this.baseUrl + "matrixHistoryKeeping" + search)
  }
  factoryPackingCycleTimelisting(search: any) {
    return this.http.get<any>(this.baseUrl + "packingUnitCycleTime/view" + search)
  }
  factoryPackingCycleTimeCreate(body: any) {
    return this.http.post<any>(this.baseUrl + "packingUnitCycleTime/create", body)
  }
  factoryPackingCycleTimeDetails(id: any) {
    return this.http.get<any>(this.baseUrl + "packingUnitCycleTime/view/" + id)
  }
  factoryPackingCycleTimeUpdate(body: any) {
    return this.http.put<any>(this.baseUrl + "packingUnitCycleTime/update", body)
  }
  factoryPackingCycleTimeDelete(body: any) {
    return this.http.delete<any>(this.baseUrl + "packingUnitCycleTime/deleteMultiple", { body: body })
  }
  factoryRMDeviationslisting(search: any) {
    return this.http.get<any>(this.baseUrl + "rm-deviation/view" + search)
  }
  factoryRMDeviationsCreate(body: any) {
    return this.http.post<any>(this.baseUrl + "rm-deviation/create", body)
  }
  factoryRMDeviationsDetails(id: any) {
    return this.http.get<any>(this.baseUrl + "rm-deviation/view/" + id)
  }
  factoryRMDeviationsUpdate(body: any) {
    return this.http.put<any>(this.baseUrl + "rm-deviation/update", body)
  }
  factoryRMDeviationsDelete(body: any) {
    return this.http.delete<any>(this.baseUrl + "rm-deviation/deleteMultiple", { body: body })
  }
  factoryLossDeviationslisting(search: any) {
    return this.http.get<any>(this.baseUrl + "loss-deviation/view" + search)
  }
  factoryLossDeviationsCreate(body: any) {
    return this.http.post<any>(this.baseUrl + "loss-deviation/create", body)
  }
  factoryLossDeviationsDetails(id: any) {
    return this.http.get<any>(this.baseUrl + "loss-deviation/view/" + id)
  }
  factoryLossDeviationsUpdate(body: any) {
    return this.http.put<any>(this.baseUrl + "loss-deviation/update", body)
  }
  factoryLossDeviationsDelete(body: any) {
    return this.http.delete<any>(this.baseUrl + "loss-deviation/deleteMultiple", { body: body })
  }
  factoryIntermediateProductCycleTimelisting(search: any) {
    return this.http.get<any>(this.baseUrl + "intermediate-production-cycle-time/view" + search)
  }
  factoryIntermediateProductCycleTimeCreate(body: any) {
    return this.http.post<any>(this.baseUrl + "intermediate-production-cycle-time/create", body)
  }
  factoryIntermediateProductCycleTimeDetails(id: any) {
    return this.http.get<any>(this.baseUrl + "intermediate-production-cycle-time/view/" + id)
  }
  factoryIntermediateProductCycleTimeUpdate(body: any) {
    return this.http.put<any>(this.baseUrl + "intermediate-production-cycle-time/update", body)
  }
  factoryIntermediateProductCycleTimeDelete(body: any) {
    return this.http.delete<any>(this.baseUrl + "intermediate-production-cycle-time/deleteMultiple", { body: body })
  }
  factoryExcelUpload(body: any) {
    return this.http.post<any>(this.baseUrl + "createFactoryProjection/excelUpload", body)
  }
  factoryProjectionCreate(body: any) {
    return this.http.post<any>(this.baseUrl + "createFactoryProjection", body)
  }
  factoryProductionListing(search: string) {
    return this.http.get<any>(this.baseUrl + "viewFactoryProjection?" + search)
  }
  factoryProductionDelete(ids: any) {
    return this.http.delete<any>(this.baseUrl + "viewFactoryProjection", { body: ids })
  }
  userTypeCreation(body: any) {
    return this.http.post<any>(this.baseUrl + "createUserType", body)
  }
  userTypeListing(search: any) {
    return this.http.get<any>(this.baseUrl + "viewUserType" + search)
  }
  userTypeDelete(body: any) {
    return this.http.delete<any>(this.baseUrl + "viewUserType", { body: body })
  }
  userTypedetails(id: any) {
    return this.http.get<any>(this.baseUrl + "viewUserType/" + id)
  }
  userTypeupdate(body: any) {
    return this.http.put<any>(this.baseUrl + "updateUserType", body)
  }

  usertypeDropdown() {
    return this.http.get<any>(this.baseUrl + "viewUserType/userTypeList/dropdown")

  }

  //messagebroadcast

  MessageBroadcastlist(search: string) {
    return this.http.get<any>(this.baseUrl + "viewWhatsappBroadcast" + search)
  }
  MessageBroadcastcreate(body: any) {
    return this.http.post<any>(this.baseUrl + "createWhatsappBroadcast", body)
  }
  MessageBroadcastFileUpload(data: any) {
  const employeeId = localStorage.getItem('admin_id') || '';
  return this.http.post<any>(this.baseUrl + "fileUpload/folder?folder_name=whatsapp_broadcast&employee_id=" + employeeId, data);
}

  // qc deviation


  viewQcdeviation(search: string) {
    return this.http.get<any>(this.baseUrl + "viewQcPermittedDeviation" + search)
  }
  //-----qc deviation updation-------
  updateQcPermittedDeviation(body: any) {
    return this.http.put<any>(this.baseUrl + "updateQcPermittedDeviation", body)
  }

  // machines

  machinesCreation(body: any) {
    return this.http.post<any>(this.baseUrl + "createWeighingMachine", body)
  }
  machinesUpdate(body: any) {
    return this.http.put<any>(this.baseUrl + "createWeighingMachine/update", body)
  }
  machinesListing(body: any) {
    return this.http.get<any>(this.baseUrl + "viewWeighingMachine" + body)
  }
  machinesDelete(body: any) {
    return this.http.delete<any>(this.baseUrl + "viewWeighingMachine", { body: body })
  }

  // hrModule

  createCandidateProfile(body: any) {
    return this.http.post<any>(this.baseUrl + "createCandidateProfile", body)
  }

  viewHiringFolder(params: string) {
    return this.http.get<any>(this.baseUrl + "viewHiringFolder" + params)
  }

  viewHiringFolderList() {
    return this.http.get<any>(this.baseUrl + "viewHiringFolder/department/lists")
  }

  viewHiringFolderEach(Id: any) {
    return this.http.get<any>(this.baseUrl + "viewHiringFolder/" + Id)
  }

  updateHiringFolder(body: any) {
    return this.http.put<any>(this.baseUrl + "updateHiringFolder", body);
  }

  updateCandidateProfile(body: any) {
    return this.http.put<any>(this.baseUrl + "updateCandidateProfile", body);
  }

  viewCandidateProfileEach(Id: any) {
    return this.http.get<any>(this.baseUrl + "viewCandidateProfile/" + Id)
  }
  viewCandidateProfileTemplate(Id: any) {
    return this.http.get<any>(this.baseUrl + "viewCandidateProfile/" + Id + '/offerLetter-templates')
  }
  deletCandidateProfileEach(body: any) {
    return this.http.delete<any>(this.baseUrl + "viewCandidateProfile", { body: body })
  }

  viewCandidateProfile(Id: any) {
    return this.http.get<any>(this.baseUrl + "viewCandidateProfile" + Id)
  }
  viewHiringrequest(search: string) {
    return this.http.get<any>(this.baseUrl + "viewHiringRequest" + search)
  }
  CreateHiringrequest(body: any) {
    return this.http.post<any>(this.baseUrl + "createHiringRequest", body)
  }
  UpdateHiringrequest(body: any) {
    return this.http.put<any>(this.baseUrl + "updateHiringRequest", body)
  }
  detailHiringrequest(id: string) {
    return this.http.get<any>(this.baseUrl + "viewHiringRequest/" + id)
  }
  viewHiringrequestPendingCount() {
    return this.http.get<any>(this.baseUrl + "viewHiringRequest/pending/count")
  }
  brandDropdown() {
    return this.http.get<any>(this.baseUrl + "viewBrands/brand_dropdown")
  }
  jobroleDropdown() {
    return this.http.get<any>(this.baseUrl + "viewJobRole")
  }
  viewCountry() {
    return this.http.get<any>(this.baseUrl + "viewCountry")
  }
  viewJoblocation(id: string) {
    return this.http.get<any>(this.baseUrl + "viewJobLocation?country_id=" + id)
  }


  // rfr api calls

  viewCustomer(id: string, customername: string) {
    return this.http.get<any>(this.baseUrl + "viewCustomerDailyCron?customer_name=" + customername + "&employee_id=" + id)
  }
  RfrMultipleCreation(body: any) {
    return this.http.post<any>(this.baseUrl + "createRequestForResolution", body)
  }

  // dashboard
  dashboardPiechart(EmpId: any, body: any, searchdata: string) {
    return this.http.post<any>(this.baseUrl + "viewDashboard/admin/" + EmpId + searchdata, body)
  }
  dashboardPiechartEmployeeWise(EmpId: any, searchdata: string) {
    var body = {}
    return this.http.post<any>(this.baseUrl + "viewDashboard/sales_persons/" + EmpId + searchdata, body)
  }
  postDashboardCustomerIds(participantId: string, yearMonth: string, sortBy: string, customerIds: string[]) {
    return this.http.post<any>(this.baseUrl + 'viewDashboard/customer_wise/cron_listing/' + participantId + '?year_month=' + yearMonth + '&last_3_month_sales_avg=' + sortBy + '&sort_by=last_3_month_sales_avg', { customer_ids: customerIds });
  }
  getLeadsCustomerList(employeeId: string, customerIds: string[]) {
    return this.http.post<any>(this.baseUrl + 'viewCustomerDailyCron/Leads/customer_lists?employee_id=' + employeeId, { customer_ids: customerIds });
  }
  DepartmentDropdown() {
    return this.http.get<any>(this.baseUrl + "viewDepartments/department_dropdown")
  }
  UserDropdown() {
    return this.http.get<any>(this.baseUrl + "viewLogin/user_list/user_dropdown")
  }
  whatsappReplay(body: any) {
    return this.http.post<any>(this.baseUrl + "createWhatsappBroadcast/replyMessage", body)
  }

  // rft api calls

  viewRft(paramsVal: string) {
    return this.http.get<any>(this.baseUrl + "viewRequestForTechnician" + paramsVal)
  }

  deleteRft(body: any) {
    return this.http.delete<any>(this.baseUrl + "viewRequestForTechnician/delete/multiple", { body: body })
  }

  // settings
  // app settings

  viewappSetting() {
    return this.http.get<any>(this.baseUrl + "viewAppSettings")
  }

  updateppSetting(body: any) {
    return this.http.put<any>(this.baseUrl + "updateAppSettings", body)
  }

  // hiring folder
  // interview define

  createDefaultrounds(body: any) {
    return this.http.post<any>(this.baseUrl + "createDefine", body)
  }
  createInterview(body: any) {
    return this.http.put<any>(this.baseUrl + "updateDefine/add_round", body)
  }

  deleteInterview(body: any) {
    return this.http.put<any>(this.baseUrl + "updateDefine/remove_rounds", body)
  }
  viewDefineInterview() {
    return this.http.get<any>(this.baseUrl + "viewDefine")
  }

  CreateDefineInterview(body: any) {
    return this.http.post<any>(this.baseUrl + "CreateDefineInterviewCriteria", body)
  }
  updateDefineInterview(body: any) {
    return this.http.put<any>(this.baseUrl + "updateDefineInterviewCriteria", body)
  }
  viewDefineInterviewcritirea(id: any, jobId: string, departmentId: string) {
    return this.http.get<any>(this.baseUrl + "viewDefineInterviewCriteria/" + id + '?job_role_id=' + jobId + '&department_id=' + departmentId);
  }

  updateInterview(body: any) {
    return this.http.put<any>(this.baseUrl + "updateCandidateProfile/updateInterview", body)
  }
  // Interveiw Schedule
  viewInterview(search: any) {
    return this.http.get<any>(this.baseUrl + "viewScheduledInterviews" + search)
  }
  updatemarkInterview(body: any) {
    return this.http.put<any>(this.baseUrl + "updateScheduledInterviews", body)
  }

  // quickCreations

  countryCreation(body: any) {
    return this.http.post<any>(this.baseUrl + "createCountry", body)
  }
  jobLocationCreation(body: any) {
    return this.http.post<any>(this.baseUrl + "createJobLocation", body)
  }
  jobRole(body: any) {
    return this.http.post<any>(this.baseUrl + "createJobRole", body)
  }

  // excel download

  getExcel(id: any) {
    return this.http.get(this.baseUrl + "viewCandidateProfile/excelFile/" + id, { responseType: 'blob' })
  }
  getExcelreport(string: any) {
    return this.http.get(this.baseUrl + "viewProduction/list/productionStatusReport/excelExport" + string, { responseType: 'blob' })
  }
  // dashboard
  hrDashboard(id: any) {
    return this.http.get<any>(this.baseUrl + "viewHiringDashboard/" + id)
  }
  sentEmail(body: any) {
    return this.http.post<any>('http://192.168.0.187:5000/createSendOfferLetter', body)
  }
  sentEmailran(body: any) {
    return this.http.post<any>(this.baseUrl + 'createSendOfferLetter', body)
  }

  outofstockView(search: string) {
    return this.http.post<any>(this.baseUrl + 'viewOutOfStock' + search, {})
  }
  outofstockDetailview(search: string) {
    return this.http.get<any>(this.baseUrl + 'viewOutOfStock' + search)
  }
  outofstockExcel(search: string) {
    return this.http.get(this.baseUrl + 'viewOutOfStock/list/excelCreation' + search, { responseType: 'blob' })
  }
  createOutOfStock(body: any) {
    return this.http.post<any>(this.baseUrl + "createOutOfStock", body);
  }

  pdfSave(body: object) {
    return this.http.post(this.baseUrl + 'createSendOfferLetter/save-offerLetter', body)
  }

  onboarding(body: any) {
    return this.http.post(this.baseUrl + 'createOnboardCandidates', body)
  }
  onboardingmembers(body: any) {
    return this.http.get<any>(this.baseUrl + 'viewOnboardCandidates' + body)
  }
  onboardingmembersUpdate(body: any) {
    return this.http.put<any>(this.baseUrl + 'updateOnboardCandidates', body)
  }
  onboardingDocumentType() {
    return this.http.get(this.baseUrl + 'documentType')
  }
  onboardingDocumentTypelist(search: string) {
    return this.http.get<any>(this.baseUrl + 'documentType' + search)
  }
  onboardingDocumentTypeCreation(body: any) {
    return this.http.post<any>(this.baseUrl + 'documentType', body)
  }
  onboardingDocumentTypeUpdate(body: any) {
    return this.http.put<any>(this.baseUrl + 'documentType', body)
  }

  onboardingDocumentTypedelete(body: any) {
    return this.http.delete<any>(this.baseUrl + "documentType", { body: body })
  }

  goalUpdate(body: any) {
    return this.http.put<any>(this.baseUrl + "updateOnboardCandidates/goals", body)
  }
  assetUpdate(body: any) {
    return this.http.put<any>(this.baseUrl + "updateOnboardCandidates/updateAssets", body)
  }
  assetDelete(body: any) {
    return this.http.put<any>(this.baseUrl + "updateOnboardCandidates/updateAssets", body)
  }
  getGoal(search: string) {
    return this.http.get<any>(this.baseUrl + "viewOnboardCandidates/onBoarded/goals" + search)
  }
  // factory punching apis
  factoryPuncingList(search: string) {
    return this.http.get<any>(this.baseUrl + "viewFactoryPunching" + search)
  }
  factoryPunchingUpdate(body: string) {
    return this.http.put<any>(this.baseUrl + "viewFactoryPunching/updateFactoryPunchings", body)
  }



  factoryPuncingListExcel(search: string) {
    return this.http.get(this.baseUrl + "viewFactoryPunching/excelExport" + search, { responseType: 'blob' })
  }

  //template

  createTemplate(body: any) {
    return this.http.post<any>(this.baseUrl + "performanceTemplate", body)
  }
  updateTemplate(body: any) {
    return this.http.put<any>(this.baseUrl + "performanceTemplate", body)
  }
  listTemplate(search: any) {
    return this.http.get<any>(this.baseUrl + "performanceTemplate" + search)
  }
  dropdownTemplate() {
    return this.http.get<any>(this.baseUrl + 'performanceTemplate/template/dropdown')
  }

  deleteTemplate(ids: any) {
    return this.http.delete<any>(this.baseUrl + "performanceTemplate", { body: ids })
  }
  AssetCreate(body: any) {
    return this.http.post<any>(this.baseUrl + "assets", body)
  }
  Assetupdate(body: any) {
    return this.http.put<any>(this.baseUrl + "assets", body)
  }
  AssetList(search: any) {
    return this.http.get<any>(this.baseUrl + "assets" + search)
  }
  dropAssetDropdown() {
    return this.http.get<any>(this.baseUrl + "assets")
  }
  AssetDelete(body: any) {
    return this.http.delete<any>(this.baseUrl + "assets", { body: body })
  }
  assetHistory(id: any) {
    return this.http.get<any>(this.baseUrl + 'assetsHistory/' + id)
  }


  // department edit fn

  industryType() {
    return this.http.get<any>(this.baseUrl + "viewIndustryType")
  }
  //meeting schedule apis
  getappIndustryDropdown() {
    return this.http.get<any>(this.baseUrl + "appIndustry/view/list/dropdown")
  }

  getIndustryTypeDropdown(name: string = '', offset: number = 0, limit: number = 20) {
    return this.http.get(`${this.baseUrl}/viewIndustryType?name=${name}&offset=${offset}&limit=${limit}`);
  }

  // app category dropdown
  viewAppCategory() {
    return this.http.get<any>(this.baseUrl + 'viewAppCategory');
  }
  salesPromoter(searchFiler: any) {
    return this.http.get<any>(this.baseUrl + "viewEmployees/employee_list/userTypeWise?user_type=Sales_Promoter")
  }
  salesEmployees() {
    return this.http.get<any>(this.baseUrl + "viewEmployees/employee_list/salesRelatedEmployeesDropdown")
  }

  // new scheduled api changes for the sales drop column apis in the customer report

  // RFT detail view
  getRftByNo(rftNo: string) {
    return this.http.get<any>(this.baseUrl + 'viewRequestForTechnician?sort_by=begin_date&offset=0&limit=1&rft_no=' + rftNo);
  }
  // Brand/Competitor list for meeting
  getSalesMeetingCompetitorList() {
    return this.http.get<any>(this.baseUrl + "viewSalesMeeting/competitors/list");
  }

  getCompetitorList() {
    return this.http.get<any>(this.baseUrl + "viewSalesMeeting/competitors/list");
  }

    getActionPlanProgress(participantId: string, year: string, type: string = 'customer') {
  return this.http.get<any>(this.baseUrl + "viewSalesMeeting/summary/customerActionPlanGraph?participant_id=" + participantId + "&year=" + year + "&type=" + type);
}

  getSalesDropRftList(customerId: string) {
    return this.http.get<any>(this.baseUrl + "viewSalesMeeting/rft/troubleshooting/" + customerId);
  }

  getSalesDropRemakeList(customerId: string) {
    return this.http.get<any>(this.baseUrl + "viewSalesMeeting/remake/" + customerId);
  }

  validatePaymentIssue(customerId: string) {
    return this.http.get<any>(this.baseUrl + "viewSalesMeeting/paymentIssue/validate/" + customerId);
  }

  // ✅ Get team members for a specific manager
  getManagerTeamMembers(managerId: string) {
    return this.http.get<any>(
      this.baseUrl + "viewEmployees/salesTeam/teammatesDropdown?employee_id=" + managerId
    );
  }

  createSecheduleMeedting(body: any) {
    return this.http.post<any>(this.baseUrl + "createMeetingScheduler", body)
  }
  listSecheduleMeeting(filter: any) {
    return this.http.get<any>(this.baseUrl + "viewSalesMeeting" + filter)
  }
  updateSecheduleMeeting(body: any) {
    return this.http.put<any>(this.baseUrl + "updateSalesMeeting", body)
  }
  getTierClassificationSummary(participant_id: string, year: string) {
    return this.http.get<any>(this.baseUrl + "viewSalesMeeting/summary/tierClassification?participant_id=" + participant_id + "&year=" + year)
  }

  // factory devices api

  createFactoryDevice(body: any) {
    return this.http.post<any>(this.baseUrl + "createFactoryDevice", body)
  }
  updateFactoryDevice(body: any) {
    return this.http.put<any>(this.baseUrl + "updateFactoryDevice", body)
  }
  viewFactoryDevice(search: any) {
    return this.http.post<any>(this.baseUrl + "viewFactoryDevice", search)
  }
  viewFactoryDeviceDetails(search: any) {
    return this.http.get<any>(this.baseUrl + "viewFactoryDevice" + search)
  }
  FactoryDeviceDelete(body: any) {
    return this.http.delete<any>(this.baseUrl + "viewFactoryDevice", { body: body })
  }
  userMenuListing(search: any) {
    return this.http.get<any>(this.baseUrl + "viewMenu" + search)
  }
  userMenuDropdown() {
    return this.http.get<any>(this.baseUrl + "viewMenu/list/dropdown")
  }
  userMenuCreation(body: any) {
    return this.http.post<any>(this.baseUrl + "createMenu", body)
  }
  userMenuDelete(body: any) {
    return this.http.delete<any>(this.baseUrl + "viewMenu", { body: body })
  }
  userMenuTree(user_id: string) {
    return this.http.get<any>(this.baseUrl + "viewMenu/userTypeMenu/tree" + user_id)
  }
  userMenuPrivilageCreation(body: any) {
    return this.http.post<any>(this.baseUrl + "createUserTypeMenu", body)
  }
  factorySettingsListing() {
    return this.http.get<any>(this.baseUrl + "viewFactorySettings")
  }
  factorySettingsListingshift() {
    return this.http.get<any>(this.baseUrl + "viewFactorySettings")
  }
  updateFactorySettings(body: any) {
    return this.http.post<any>(this.baseUrl + "updateFactorySettings", body)
  }
  mobilePuncingList(search: string) {
    return this.http.get<any>(this.baseUrl + "viewFactoryAppPunching/list/webView" + search)
  }


  // marketingTeam apis

  marketingTeamCreate(body: any) {
    return this.http.post<any>(this.baseUrl + "createMarketingTeam", body);
  }
  marketingTeamUpdate(body: any) {
    return this.http.patch<any>(this.baseUrl + "updateMarketingTeam", body);
  }

  marketingTeamList(search: string) {
    return this.http.get<any>(this.baseUrl + "viewMarketingTeam" + search);
  }
  marketingTeamDelete(body: any) {
    return this.http.delete<any>(this.baseUrl + "viewMarketingTeam", { body: body });
  }

  // Employee sales target
  ViewEmployeeListing(params: any) {
    return this.http.get<any>(this.baseUrl + "viewEmployees" + params);
  }


  usertypeEmployee(type: any) {
    if (!type) {
      type = ""
    }
    return this.http.get<any>(this.baseUrl + "viewEmployees/employee_list/userTypeWise?user_type=" + type);
  }


  // employee monthly target
  employeeMonthlyTarget(body: any) {
    return this.http.post<any>(this.baseUrl + "employeeMonthlySalesTarget/create", body);
  }

  getEmployeeTarget(searchString: string) {
    return this.http.get<any>(this.baseUrl + "employeeMonthlySalesTarget/view" + searchString);
  }

  getGoalShecdule(search: string) {
    return this.http.get<any>(this.baseUrl + "viewOnboardCandidates/onBoarded/goals" + search)
  }



  // google map loading fn

  private isLoaded = false;

  loadGoogleMaps(apiKey: string, libraries: string = 'places'): Promise<void> {
    if (this.isLoaded) return Promise.resolve();

    return new Promise((resolve, reject) => {
      const scriptId = 'google-maps-script';

      if (document.getElementById(scriptId)) {
        this.isLoaded = true;
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.id = scriptId;
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=${libraries}`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        this.isLoaded = true;
        resolve();
      };

      script.onerror = () => {
        console.error('🛑 Google Maps failed to load.');
        reject('Google Maps failed to load');
      };

      document.body.appendChild(script);
    });
  }

  // Factory Checklist Management APIs
  factoryChecklistCreate(body: any) {
    return this.http.post<any>(this.baseUrl + "factoryChecklist/create", body);
  }

  factoryChecklistUpdate(body: any) {
    return this.http.put<any>(this.baseUrl + "factoryChecklist/update", body);
  }

  factoryChecklistView(search: string) {
    return this.http.get<any>(this.baseUrl + "factoryChecklist/view" + search);
  }

  factoryChecklistViewById(id: string) {
    return this.http.get<any>(this.baseUrl + "factoryChecklist/view/" + id);
  }

  factoryChecklistDelete(body: any) {
    return this.http.delete<any>(this.baseUrl + "factoryChecklist", { body: body });
  }

  // Add this method near your other RFR methods (around line 280-300 where viewRequestForResolution is)

  viewRequestForResolutionExcel(searchParams: string) {
    this.admin_id = localStorage.getItem('admin_id');
    const url = this.baseUrl + "viewMyEvent/list/excelExport?user_id=" + this.admin_id + searchParams;
    return this.http.get(url, { responseType: 'blob' });
  }
  //apis for the technician masters //

  // Technician Master APIs
  technicianMasterCreate(body: any) {
    return this.http.post<any>(this.baseUrl + "rftTechnicians/create", body);
  }

  technicianMasterUpdate(body: any) {
    return this.http.put<any>(this.baseUrl + "rftTechnicians/update", body);
  }

  technicianMasterList(search: string) {
    return this.http.get<any>(this.baseUrl + "rftTechnicians/list" + search);
  }

  technicianMasterDropdown() {
    return this.http.get<any>(this.baseUrl + "rftTechnicians/dropdown");
  }

  // apis for the job role hierarchy//

  jobRoleCreate(body: any) {
    return this.http.post<any>(this.baseUrl + "jobRoles/create", body);
  }
  jobRoleUpdate(body: any) {
    return this.http.put<any>(this.baseUrl + "jobRoles/update", body);
  }
  jobRoleDelete(body: any) {
    return this.http.delete<any>(this.baseUrl + "jobRoles/delete", { body: body });
  }
  jobRoleHierarchyCreate(body: any) {
    return this.http.post<any>(this.baseUrl + "jobRoleHierarchy/create", body);
  }
  jobRoleHierarchyUpdate(body: any) {
    return this.http.put<any>(this.baseUrl + "jobRoleHierarchy/update", body);
  }
  jobRoleHierarchyList(search: string = '') {
    const t = new Date().getTime();
    return this.http.get<any>(this.baseUrl + "jobRoleHierarchy/list" + search + (search ? '&' : '?') + '_t=' + t);
  }
  jobRoleHierarchyDelete(body: any) {
    return this.http.delete<any>(this.baseUrl + "jobRoleHierarchy/delete", { body: body });
  }
  jobroleDropdownnew(filter: string = 'all') {
    const t = new Date().getTime();
    return this.http.get<any>(this.baseUrl + "jobRoles/dropdown?filter_type=" + filter + "&_t=" + t);
  }
  jobRoleHierarchyChart() {
    const t = new Date().getTime();
    return this.http.get<any>(this.baseUrl + "jobRoleHierarchy/chart?_t=" + t);
  }
  jobRoleList(search: string = '') {
    return this.http.get<any>(this.baseUrl + "jobRoles/list" + search);
  }

  // monthly meeting report excel download//

  exportMeetingExcel(filter: string) {
    return this.http.get(this.baseUrl + "viewSalesMeeting/export/excel" + filter, { responseType: 'blob' });
  }

  refreshMeetingValues(body: any) {
    return this.http.put<any>(this.baseUrl + "updateSalesMeeting/refreshValues", body);
  }

  refreshAgreedSalesThisMonthValue(body: any) {
  return this.http.put<any>(this.baseUrl + "updateSalesMeeting/refreshAgreedSalesThisMonthValue", body);
}

  // rfr responsible employees//

  // After
  ViewRfrResponsibleEmployees() {
    return this.http.get<any>(this.baseUrl + "viewDepartments/rfr_responsible_employees?limit=100");
  }

  UpdateRfrResponsibleEmployee(body: any) {
    return this.http.put<any>(this.baseUrl + "updateDepartments", body);
  }

  // Excluded RFR users
  getExcludedRfrEmployees() {
    return this.http.get<any>(this.baseUrl + "rfrExcludedEmployee/list");
  }

  updateExcludedRfrEmployees(body: { employees: { employee_id: string; employee_name: string }[] }) {
    return this.http.put<any>(this.baseUrl + "rfrExcludedEmployee/update", body);
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // Leave Request APIs
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. View leave requests (with filters & pagination)
  viewLeaveRequest(offset = 0, status = '', leave_type = '', from_date = '', to_date = '', employee_id = '', limit = 20) {
    const params: any = { offset, limit };
    if (status) params.status = status;
    if (leave_type) params.leave_type = leave_type;
    if (from_date) params.from_date = from_date;
    if (to_date) params.to_date = to_date;
    if (employee_id) params.employee_id = employee_id;

    return this.http.get<any>(this.baseUrl + 'viewLeaveRequest', { params });
  }

  // 2. View single leave request by ID
  viewLeaveRequestById(_id: string) {
    return this.http.get<any>(this.baseUrl + `viewLeaveRequest/${_id}`);
  }

  // 3. Create a new leave request
  createLeaveRequest(body: any) {
    return this.http.post<any>(this.baseUrl + 'createLeaveRequest', body);
  }

  // 4. Update a single leave request
  updateLeaveRequest(body: any) {
    return this.http.put<any>(this.baseUrl + 'updateLeaveRequest', body);
  }

  // 5. Bulk update leave requests
  bulkUpdateLeaveRequest(body: any) {
    return this.http.put<any>(this.baseUrl + 'updateLeaveRequest/bulk', body);
  }

  // ── For counts only — high limit, no pagination ──
  viewLeaveRequestCounts(leave_type = '', from_date = '', to_date = '', employee_id = '') {
    const params: any = { offset: 0, limit: 5000 };
    if (leave_type) params.leave_type = leave_type;
    if (from_date) params.from_date = from_date;
    if (to_date) params.to_date = to_date;
    if (employee_id) params.employee_id = employee_id;
    // ← NO status filter, so all statuses come back

    return this.http.get<any>(this.baseUrl + 'viewLeaveRequest', { params });
  }

  // Leave Filter State (persists across navigation)
  leaveFilterState = {
    filterStatus: '',
    filterLeaveType: '',
    filterFromDate: '',
    filterToDate: '',
    filterEmployeeId: '',
    count: 0,
    New_count: 0,
    scrollTop: 0,
    limit: 20,
  };

  resetLeaveFilterState(): void {
    this.leaveFilterState = {
      filterStatus: '',
      filterLeaveType: '',
      filterFromDate: '',
      filterToDate: '',
      filterEmployeeId: '',
      count: 0,
      New_count: 0,
      scrollTop: 0,
      limit: 20,
    };
  }
  //apis for the standard lead matrix//
  standardLeadTimeMatrixListing(search: string) {
  return this.http.get<any>(this.baseUrl + 'leadTimeBenchmarkMatrix' + search);
}
 
standardLeadTimeMatrixCreate(body: any) {
  return this.http.post<any>(this.baseUrl + 'leadTimeBenchmarkMatrix', body);
}
 
standardLeadTimeMatrixDetails(id: string) {
  return this.http.get<any>(this.baseUrl + 'leadTimeBenchmarkMatrix/' + id);
}
 
standardLeadTimeMatrixUpdate(body: any) {
  return this.http.put<any>(this.baseUrl + 'leadTimeBenchmarkMatrix', body);
}
 
standardLeadTimeMatrixDelete(body: any) {
  return this.http.delete<any>(this.baseUrl + 'leadTimeBenchmarkMatrix', { body: body });
}

// end of the standard lead time matrix

// apis for the throughput matrixes//
throughputTimeBenchmarkMatrixListing(search: string) {
  return this.http.get<any>(this.baseUrl + 'throughputTimeBenchmarkMatrix' + search);
}

throughputTimeBenchmarkMatrixCreate(body: any) {
  return this.http.post<any>(this.baseUrl + 'throughputTimeBenchmarkMatrix', body);
}

throughputTimeBenchmarkMatrixDetails(id: string) {
  return this.http.get<any>(this.baseUrl + 'throughputTimeBenchmarkMatrix/' + id);
}

throughputTimeBenchmarkMatrixUpdate(body: any) {
  return this.http.put<any>(this.baseUrl + 'throughputTimeBenchmarkMatrix', body);
}

throughputTimeBenchmarkMatrixDelete(body: any) {
  return this.http.delete<any>(this.baseUrl + 'throughputTimeBenchmarkMatrix', { body: body });
}

// end of the standard lead time matrix

// MIXING II MACHINE APIS (LIVE SCALE INTEGRATION) //
viewMixingJobList(status?: string, params?: any) {
  const userType = (localStorage.getItem('userTypecon') || '').toLowerCase();
  const isAdmin = userType === 'admin';
  let query = '';
  if (!isAdmin) {
    const loginUserId = localStorage.getItem('admin_id') || '';
    query = `?login_user_id=${loginUserId}`;
  }
  if (status) query += query ? `&status=${status}` : `?status=${status}`;
  if (params?.customer_tier_level) query += query ? `&customer_tier_level=${params.customer_tier_level}` : `?customer_tier_level=${params.customer_tier_level}`;
  return this.http.get<any>(this.baseUrl + 'viewMixingJobList' + query);
}

viewMixingJobListByCustomer(customerId: string, status?: string, loginUserId?: string) {
  const userType = (localStorage.getItem('userTypecon') || '').toLowerCase();
  const isAdmin = userType === 'admin';
  let query = '';
  if (!isAdmin) {
    const userId = loginUserId || localStorage.getItem('admin_id') || '';
    if (userId) query += `?login_user_id=${userId}`;
  }
  if (status) query += query ? `&status=${status}` : `?status=${status}`;
  return this.http.get<any>(this.baseUrl + 'viewMixingJobList/' + customerId + query);
}

updateMixingJobList(body: any) {
  return this.http.put<any>(this.baseUrl + 'updateMixingJobList', body);
}
getMixingFormulaList(params?: any) {
  return this.http.get<any>(this.baseUrl + 'mixingFormula', { params: params || {} });
}

deleteMixingFormula(body: { _id: string }) {
  return this.http.delete<any>(this.baseUrl + 'mixingFormula', { body: body });
}

SearchProductByBarcode(barcode: string) {
  return this.http.get<any>(this.baseUrl + "viewProducts?barcode=" + barcode);
}

SearchRmTransferByBarcode(barcode: string) {
  return this.http.get<any>(this.baseUrl + "viewRmTransfer/rmTransferList/barcode?barcode=" + barcode);
}

getPaintTypesByArea(paintAreaId: string) {
  return this.http.get<any>(this.baseUrl + 'paint_type/view/' + paintAreaId);
}
addMixingIngredient(body: any) {
  return this.http.put<any>(this.baseUrl + 'updateMixingJobList/addIngredients', body);
}

// INVENTORY TRANSFER EXCEL DOWNLOAD //
downloadScanAdherenceExcel(fromDate: string, toDate: string) {
  return this.http.get(
    this.baseUrl + `viewInventoryTransfer/inventoryTransfer/excel?from_date=${fromDate}&to_date=${toDate}`,
    { responseType: 'blob', observe: 'response' }
  );
}
// LEADS REPORT API IN THE FACTORY //
leadThroughputTimeSummaryReport(search: string) {
  return this.http.get<any>(this.baseUrl + 'leadThroughputTimeSummaryReport' + search);
}

leadThroughputTimeSummaryReportExcelDownload(search: string) {
  return this.http.get(this.baseUrl + 'leadThroughputTimeSummaryReport/download' + search, {
    responseType: 'blob'
  });
}
// ─── Sample Request Factory Flow APIs ───────────────────────────────────────

getSampleRequestFactoryFlowList(offset: number, limit: number, search: string) {
  return this.http.get(
    `${this.baseUrl}sampleRequestFactoryFlow?offset=${offset}&limit=${limit}&search=${search}`
  );
}

createSampleRequestFactoryFlow(payload: any) {
  return this.http.post(
    `${this.baseUrl}sampleRequestFactoryFlow`,
    payload
  );
}

updateSampleRequestFactoryFlow(id: string, payload: any) {
  return this.http.put(
    `${this.baseUrl}sampleRequestFactoryFlow/${id}`,
    payload
  );
}

deleteSampleRequestFactoryFlow(id: string) {
  return this.http.delete(
    `${this.baseUrl}sampleRequestFactoryFlow/${id}`
  );
}
getSampleRequestFactoryFlowById(id: string) {
  return this.http.get(
    `${this.baseUrl}sampleRequestFactoryFlow/${id}`
  );
}
// entity api. //
getEntities() {
  return this.http.get<any>(this.baseUrl + 'entities');
}

getAbcClassificationReport(fromDate: string, toDate: string, entityId: string, departmentId: string = '', brandId: string = '') {
  let url = this.baseUrl + `abcClassificationReport/productSalesListing?from_date=${fromDate}&to_date=${toDate}&entity=${entityId}`;
  if (departmentId) url += `&department_id=${departmentId}`;
  if (brandId) url += `&brand_id=${brandId}`;
  return this.http.get<any>(url);
}

getAbcClassificationSummary(fromDate: string, toDate: string) {
  return this.http.get<any>(this.baseUrl + `abcClassificationReport/productSalesReport?from_date=${fromDate}&to_date=${toDate}`);
}

downloadAbcClassificationExcel(fromDate: string, toDate: string, entityId: string, departmentId: string = '', brandId: string = '') {
  let url = this.baseUrl + `abcClassificationReport/productSalesReport?from_date=${fromDate}&to_date=${toDate}&entity=${entityId}`;
  if (departmentId) url += `&department_id=${departmentId}`;
  if (brandId) url += `&brand_id=${brandId}`;
  return this.http.get(url, { responseType: 'blob', observe: 'response' });
}
// master uom list api //
masterUomDropdown() {
  return this.http.get<any>(this.baseUrl + "master_uom_list/dropdown/list");
}

// RFR Testing____________________-

// Verify details
verifyAttendance(rfr_id: string) {
  return this.http.get<any>(this.baseUrl + `viewRequestForResolution/verifyAttendance/${rfr_id}`);
}

rejoinedVerify(rfr_id: string) {
  return this.http.get<any>(this.baseUrl + `viewRequestForResolution/rejoined_verify/${rfr_id}`);
}

getAbsenceRfrs(offset = 0, limit = 20, requestedToId = '', employeeId = '', createdAtDate = '') {
    const rt = requestedToId ? `&user_id=${requestedToId}` : '';
    const emp = employeeId ? `&employee_id=${employeeId}` : '';
    const date = createdAtDate ? `&created_at_date=${createdAtDate}` : '';
    return this.http.get<any>(this.baseUrl + `viewRequestForResolution/rfr/viewRfrList?complaint_about=Continuous Absence&offset=${offset}&limit=${limit}${rt}${emp}${date}`);
}

getRejoiningRfrs(offset = 0, limit = 20, requestedToId = '', employeeId = '', createdAtDate = '') {
    const rt = requestedToId ? `&user_id=${requestedToId}` : '';
    const emp = employeeId ? `&employee_id=${employeeId}` : '';
    const date = createdAtDate ? `&created_at_date=${createdAtDate}` : '';
    return this.http.get<any>(this.baseUrl + `viewRequestForResolution/rfr/viewRfrList?complaint_about=Rejoining Verification&offset=${offset}&limit=${limit}${rt}${emp}${date}`);
}

// productivity weightage config apis //
productivityWeightageConfigListing(search: string) {
  return this.http.get<any>(this.baseUrl + "productivityWeightageConfig" + search);
}

productivityWeightageConfigCreate(body: any) {
  return this.http.post<any>(this.baseUrl + "productivityWeightageConfig", body);
}

productivityWeightageConfigUpdate(body: any) {
  return this.http.put<any>(this.baseUrl + "productivityWeightageConfig", body);
}

productivityWeightageConfigDelete(id: string, body?: any) {
  return this.http.delete<any>(this.baseUrl + "productivityWeightageConfig/" + id, { body });
}

// productivity workload matrix apis //
productivityWorkloadMatrixListing(search: string) {
  return this.http.get<any>(this.baseUrl + "productivityWorkloadMatrix" + search);
}

productivityWorkloadMatrixCreate(body: any) {
  return this.http.post<any>(this.baseUrl + "productivityWorkloadMatrix", body);
}

productivityWorkloadMatrixUpdate(body: any) {
  return this.http.put<any>(this.baseUrl + "productivityWorkloadMatrix", body);
}

productivityWorkloadMatrixDelete(id: string, body?: any) {
  return this.http.delete<any>(this.baseUrl + "productivityWorkloadMatrix/" + id, { body });
}

productivityTargetConfigListing(search: string) {
  return this.http.get<any>(this.baseUrl + "productivityTargetConfig" + search);
}

productivityTargetConfigCreate(body: any) {
  return this.http.post<any>(this.baseUrl + "productivityTargetConfig", body);
}

productivityTargetConfigUpdate(body: any) {
  return this.http.put<any>(this.baseUrl + "productivityTargetConfig", body);
}

productivityTargetConfigDelete(id: string, body?: any) {
  return this.http.delete<any>(this.baseUrl + "productivityTargetConfig/" + id, { body });
}

personWiseReportListing(search: string) {
  return this.http.get<any>(this.baseUrl + "productivityReport/personWise" + search);
}

personWiseReportExcelDownload(search: string) {
  return this.http.get(this.baseUrl + "productivityReport/personWiseExcelDownload" + search, {
    responseType: 'blob'
  });
}
batchWiseReportListing(search: string) {
  return this.http.get<any>(this.baseUrl + "productivityReport/BatchWise" + search);
}
ideasuggestiondepartmentDropdown() {
    return this.http.get<any>(this.baseUrl + "factoryIdeaSuggestion/admin/departments");
  }

  assignIdeaDepartmentHead(body: any) {
  return this.http.put<any>(this.baseUrl + "factoryIdeaSuggestion/admin/assignDepartmentHead", body);
}

// productivity quality excellence matrix apis //
qualityExcellenceMatrixListing(search: string) {
  return this.http.get<any>(this.baseUrl + "qualityExcellenceMatrix" + search);
}

qualityExcellenceMatrixCreate(body: any) {
  return this.http.put<any>(this.baseUrl + "qualityExcellenceMatrix", body);
}

qualityExcellenceMatrixUpdate(body: any) {
  return this.http.put<any>(this.baseUrl + "qualityExcellenceMatrix", body);
}

qualityExcellenceMatrixDelete(body?: any) {
  return this.http.delete<any>(this.baseUrl + "qualityExcellenceMatrix", { body });
}
qualityExcellenceReport(search: string) {
  return this.http.get<any>(this.baseUrl + "qualityExcellenceReport" + search);
}

// rm qc quality excellence matrix apis //
rmQcQualityExcellenceMatrixListing(id: string) {
    return this.http.get(this.baseUrl + 'rmQcQualityExcellenceMatrix' + (id ? '/' + encodeURIComponent(id) : ''));
  }
rmQcQualityExcellenceMatrixCreate(body: any) {
  return this.http.post<any>(this.baseUrl + "rmQcQualityExcellenceMatrix", body);
}
rmQcQualityExcellenceMatrixUpdate(body: any) {
  return this.http.put<any>(this.baseUrl + "rmQcQualityExcellenceMatrix", body);
}
rmQcQualityExcellenceMatrixDelete(body: any) {
  return this.http.delete<any>(this.baseUrl + "rmQcQualityExcellenceMatrix", { body: body });
}
rmQcQualityExcellenceReport(search: string) {
  return this.http.get<any>(this.baseUrl + "rmQcQualityExcellenceReport" + search);
}

// machine criticality benchmark matrix apis //
machineCriticalityBenchmarkMatrixListing(search: string) {
  return this.http.get<any>(this.baseUrl + "machineCriticalityBenchmarkMatrix" + search);
}

machineCriticalityBenchmarkMatrixCreate(body: any) {
  return this.http.post<any>(this.baseUrl + "machineCriticalityBenchmarkMatrix", body);
}

machineCriticalityBenchmarkMatrixUpdate(body: any) {
  return this.http.put<any>(this.baseUrl + "machineCriticalityBenchmarkMatrix", body);
}

machineCriticalityBenchmarkMatrixDelete(body: any) {
  return this.http.delete<any>(this.baseUrl + "machineCriticalityBenchmarkMatrix", { body: body });
}

// ccr qa root cause apis //
ccrRootCauseListing(search: string) {
  return this.http.get<any>(this.baseUrl + "ccrRootCause" + search);
}

ccrRootCauseCreate(body: any) {
  return this.http.post<any>(this.baseUrl + "ccrRootCause", body);
}

ccrRootCauseUpdate(body: any) {
  return this.http.put<any>(this.baseUrl + "ccrRootCause", body);
}

ccrRootCauseDelete(body: any) {
  return this.http.delete<any>(this.baseUrl + "ccrRootCause", { body: body });
}

ccrRootCauseDetail(id: string) {
  return this.http.get<any>(this.baseUrl + "ccrRootCause/" + id);
}

// ccr problem apis //
ccrProblemListing(search: string) {
  return this.http.get<any>(this.baseUrl + "ccrProblem" + search);
}

ccrProblemCreate(body: any) {
  return this.http.post<any>(this.baseUrl + "ccrProblem", body);
}

ccrProblemUpdate(body: any) {
  return this.http.put<any>(this.baseUrl + "ccrProblem", body);
}

ccrProblemDelete(body: any) {
  return this.http.delete<any>(this.baseUrl + "ccrProblem", { body: body });
}

ccrProblemDetail(id: string) {
  return this.http.get<any>(this.baseUrl + "ccrProblem/" + id);
}

// ccr qa template apis //
ccrQaTemplateListing(search: string) {
  return this.http.get<any>(this.baseUrl + "ccrQaTemplate" + search);
}

ccrQaTemplateCreate(body: any) {
  return this.http.post<any>(this.baseUrl + "ccrQaTemplate", body);
}

ccrQaTemplateUpdate(body: any) {
  return this.http.put<any>(this.baseUrl + "ccrQaTemplate", body);
}

ccrQaTemplateDelete(body: any) {
  return this.http.delete<any>(this.baseUrl + "ccrQaTemplate", { body: body });
}

ccrQaTemplateDetail(id: string) {
  return this.http.get<any>(this.baseUrl + "ccrQaTemplate/" + id);
}
downloadCustomerComplaintRegisterExcel(fromDate: string, toDate: string) {
  return this.http.get(
    this.baseUrl + `viewCustomerComplaintRegister/excelDownload?from_date=${fromDate}&to_date=${toDate}`,
    { responseType: 'blob', observe: 'response' }
  );
}
  // ═══════════════════════════════════════════════════════════════
  // AI CHAT ASSISTANT APIs — uses the same baseUrl as the rest of the app
  // ═══════════════════════════════════════════════════════════════

  private get aiUserId(): string { return localStorage.getItem('admin_id') || ''; }
  private uidParam(): string { const id = this.aiUserId; return id ? '&user_id=' + encodeURIComponent(id) : ''; }

    sendAiMessage(payload: { message: string; user_type: string; user_name: string; session_id?: string; user_id?: string }) {
    const { user_type, user_name, ...rest } = payload;
    return this.http.post(this.baseUrl + 'aiChat', { ...rest, user_id: payload.user_id ?? this.aiUserId });
  }
  streamAiMessage(payload: {
    message: string;
    user_type: string;
    user_name: string;
    session_id?: string;
    user_id?: string;
    screenshot?: string;
    screen_context?: any;
    doc_id?: string;
  }, signal?: AbortSignal): Promise<Response> {
    const { user_type, user_name, ...rest } = payload;
    return fetch(this.baseUrl + 'aiChat/stream', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...this.authHeader() },
      body: JSON.stringify({ ...rest, user_id: payload.user_id ?? this.aiUserId }),
      signal
    });
  }
  // new
extractDocument(file: File, userName: string, userType: string): Promise<any> {
  const form = new FormData();
  form.append('document', file, file.name);
  form.append('user_id', this.aiUserId);
  return fetch(this.baseUrl + 'aiChat/extract', { method: 'POST', headers: this.authHeader(), body: form })
    .then(r => r.json());
}
    getAiSessions() {
    return this.http.get(this.baseUrl + 'aiChat/sessions?user_id=' + encodeURIComponent(this.aiUserId));
  }
  getAiSession(sessionId: string) {
    return this.http.get(this.baseUrl + 'aiChat/sessions/' + sessionId + '?user_id=' + encodeURIComponent(this.aiUserId));
  }
  deleteAiSession(sessionId: string) {
    return this.http.delete(this.baseUrl + 'aiChat/sessions/' + sessionId + '?user_id=' + encodeURIComponent(this.aiUserId));
  }
  renameAiSession(sessionId: string, title: string) {
    return this.http.patch(this.baseUrl + 'aiChat/sessions/' + sessionId, {
      user_id: this.aiUserId, title
    });
  }
  searchAiSessions(q: string) {
    return this.http.get(this.baseUrl + 'aiChat/search?user_id=' + encodeURIComponent(this.aiUserId) + '&q=' + encodeURIComponent(q));
  }
    getFavorites() {
    return this.http.get(this.baseUrl + 'aiChat/favorites?user_id=' + encodeURIComponent(this.aiUserId));
  }
  addFavorite(label: string, query_text: string) {
    return this.http.post(this.baseUrl + 'aiChat/favorites', { user_id: this.aiUserId, label, query_text });
  }
  deleteFavorite(id: string) {
    return this.http.delete(this.baseUrl + 'aiChat/favorites/' + id + '?user_id=' + encodeURIComponent(this.aiUserId));
  }
    getAiQuota() {
    return this.http.get(this.baseUrl + 'aiChat/quota?user_id=' + encodeURIComponent(this.aiUserId));
  }
  getAiUsage(days: number = 30) {
    return this.http.get(this.baseUrl + 'aiChat/usage?days=' + days);
  }
  reportIssue(
    sessionId: string | null,
    userName: string,
    messages: any[],
    screenshot?: string,
    screenContext?: any,
    issueDescription?: string
  ): Observable<any> {
    return this.http.post(this.baseUrl + 'aiChat/report', {
      session_id: sessionId,
      user_name: userName,
      messages: messages.map(m => ({ role: m.role, content: m.text || m.content || '' })),
      screenshot,
      screen_context: screenContext,
      issue_description: issueDescription || ''
    });
  }

  async transcribeAudio(blob: Blob, userName: string, userType: string): Promise<string> {
    const fd = new FormData();
    fd.append('audio', blob, 'voice.webm');
    fd.append('user_name', userName);
    fd.append('user_type', userType);
    try {
      const res = await fetch(this.baseUrl + 'aiChat/transcribe', { method: 'POST', body: fd });
      if (!res.ok) return '';
      const json = await res.json();
      return (json && json.transcript ? String(json.transcript).trim() : '');
    } catch {
      return '';
    }
  }

  ViewAllDeliveryMen(userTypes: string[] = ["Driver", "Delivery_Man"]) {
  return this.http.post<any>(this.baseUrl + "viewEmployees/employee/multipleUserType", { user_types: userTypes });
}

// apis for the excel download of the sales order report and goods transfer report//

downloadSaleOrderReportExcel(fromDate: string, toDate: string, userTypes: string[], departmentIds: string[], employeeIds: string[]) {
    const params: any = {
      from_date: fromDate,
      to_date: toDate
    };
    if (userTypes && userTypes.length) params.user_type = userTypes.join(',');
    if (departmentIds && departmentIds.length) params.department_id = departmentIds.join(',');
    if (employeeIds && employeeIds.length) params.employee_id = employeeIds.join(',');

    return this.http.get(
      `${this.baseUrl}viewSalesSummary/sale_order_summary/excel`,
      {
        params,
        responseType: 'blob',
        observe: 'response'
      }
    );
  }

  downloadGoodsTransferExcel(fromDate: string, toDate: string, departmentIds: string, employeeIds: string, warehouseIds: string = '') {
    const params: any = {
      from_date: fromDate,
      to_date: toDate
    };
    if (departmentIds) params.departmentIds = departmentIds;
    if (employeeIds) params.employeeIds = employeeIds;
    if (warehouseIds) params.warehouse_id = warehouseIds;

    return this.http.get(
      `${this.baseUrl}viewInventoryTransfer/dashboard/excel`,
      {
        params,
        responseType: 'blob',
        observe: 'response'
      }
    );
  }

  // R&D review matrix apis //
rAndDReviewMatrixListing(search: string = '') {
  return this.http.get<any>(this.baseUrl + "rAndDReviewMatrix" + search);
}
rAndDReviewMatrixCreate(body: any) {
  return this.http.post<any>(this.baseUrl + "rAndDReviewMatrix", body);
}
rAndDReviewMatrixUpdate(body: any) {
  return this.http.put<any>(this.baseUrl + "rAndDReviewMatrix", body);
}
rAndDReviewMatrixDetails(id: string) {
  return this.http.get<any>(this.baseUrl + "rAndDReviewMatrix/" + id);
}
rAndDReviewMatrixDelete(id: string, body?: any) {
  return this.http.delete<any>(this.baseUrl + "rAndDReviewMatrix/" + id, { body });
}

// RM DISTRIBUTION MATRIX APIS //

RmDistributionMatrixListing(search: string = '') {
  return this.http.get<any>(this.baseUrl + "rmDistributionMatrix" + search);
}
RmDistributionMatrixCreate(body: any) {
  return this.http.post<any>(this.baseUrl + "rmDistributionMatrix", body);
}
RmDistributionMatrixUpdate(body: any) {
  return this.http.put<any>(this.baseUrl + "rmDistributionMatrix", body);
}
RmDistributionMatrixDetails(id: string) {
  return this.http.get<any>(this.baseUrl + "rmDistributionMatrix/" + id);
}
RmDistributionMatrixDelete(id: string, body?: any) {
  return this.http.delete<any>(this.baseUrl + "rmDistributionMatrix/" + id, { body });
}

// LIVE PRODUCTION DASHBOARD APIS //
liveProductionDashboard(search: string = '') {
    return this.http.get<any>(this.baseUrl + "liveProductionDashboard" + search)
  }

}
